window.addEventListener('load', () => {

    // Add the fields here if the filter field does not match the field name in the card's data attribute
    const filterFieldDataFieldMap = {
        'min-price': 'price',
        'max-price': 'price',
    };

    const showElement = (element) => {
        element.classList.remove('hidden');
    };

    const hideElement = (element) => {
        element.classList.add('hidden');
    };

    const getActiveFilters = () => {
        let filters = {};
        const clickFilters = document.querySelectorAll('.filter.filter-click.active');
        const textAndSelectFilters = document.querySelectorAll('.filter.filter-text, .filter.filter-select');
        clickFilters.forEach((filter) => {
            const filterField = filter.getAttribute('data-filter-field');
            const filterValue = filter.getAttribute('data-filter-value');
            if (filterValue && filterValue.length) {
                filters[filterField] = filterValue;
            }
        });
        textAndSelectFilters.forEach((filter) => {
            const filterField = filter.getAttribute('data-filter-field');
            const filterValue = filter.value;
            if (filterValue && filterValue.length) {
                filters[filterField] = filterValue;
            }
        });
        return filters;
    };

    const applyFilters = () => {
        const filters = getActiveFilters();
        const filterables = document.querySelectorAll('.filterable');
        filterables.forEach((filterable) => {
            let showThis = true;
            for (let [filterField, filterValue] of Object.entries(filters)) {
                if (showThis) {
                    const attributeName = (filterField in filterFieldDataFieldMap) ? `data-${filterFieldDataFieldMap[filterField]}` : `data-${filterField}`;
                    let filterableValue = filterable.getAttribute(attributeName);
                    let isFilterSatisfied = false;
                    if (filterableValue) {
                        // For fields that need special logic.
                        switch (filterField) {
                            case 'min-price':
                                isFilterSatisfied = parseFloat(filterableValue) >= parseFloat(filterValue);
                                break;

                            case 'max-price':
                            case 'min-block-width':
                                isFilterSatisfied = parseFloat(filterableValue) <= parseFloat(filterValue);
                                break;

                            case 'range':
                                isFilterSatisfied = (filterValue === 'all') || (filterableValue === filterValue);
                                break;

                            default:
                                isFilterSatisfied = filterableValue === filterValue;
                        }
                    }
                    showThis = showThis && isFilterSatisfied;
                }
                if (!showThis) {
                    break;
                }
            }
            if (showThis) {
                showElement(filterable);
            } else {
                hideElement(filterable);
            }
        });

        const resultCount = document.querySelectorAll('.filterable:not(hidden)').length;
        const emptyResultsMessage = document.querySelector('.filter-results-empty');
        if (resultCount > 1) {
            showElement(emptyResultsMessage);
        } else {
            hideElement(emptyResultsMessage);
        }
    };

    const clickFilters = document.querySelectorAll('.filter.filter-click');
    clickFilters.forEach((filter) => {
        filter.addEventListener('click', (e) => {
            const filterField = filter.getAttribute('data-filter-field');
            const otherFilters = document.querySelectorAll(`.filter.filter-click[data-filter-field="${filterField}"]`);
            otherFilters.forEach((otherFilter) => {
                if (otherFilter !== filter) {
                    otherFilter.classList.remove('active');
                }
            });
            filter.classList.add('active');
            applyFilters();
        });
    });

    const filterTrigger = document.querySelector('.filter-trigger');
    filterTrigger?.addEventListener('click', (e) => {
        applyFilters();
    });
});